import React from "react";
import { AnalyticsController } from "./AnalyticsController";
import { AnalyticsViewModel } from "./AnalyticsViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class AnalyticsProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new AnalyticsViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <AnalyticsController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Analytics/AnalyticsProvider.js